import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Agriculture from "@/assets/images/webp/industryAgriculture.webp";
import Pharmaceuticals from "@/assets/images/webp/industryPharma.webp";
import Ceramic from "@/assets/images/webp/industryCeramic.webp";
import Textiles from "@/assets/images/webp/industryTextile.webp";
import BuildingMaterials from "@/assets/images/webp/industryBuildingMaterial.webp";
import Automobile from "@/assets/images/webp/industryAutomobile.webp";
import FMCG from "@/assets/images/webp/industryFMCG.webp";
import Cosmetics from "@/assets/images/webp/industryCosmatic.webp";
import Food from "@/assets/images/webp/industryFoods.webp";
import Electronics from "@/assets/images/webp/industryElectronics.webp";
import Oil from "@/assets/images/webp/industryOil.webp";


import StatesImg from "@/assets/images/webp/marketing-stats.webp";

import SupplierCarousel from "@/modules/frontend/components/Market_Place/SupplierCarousel"
import OwlCarousel from "react-owl-carousel";

import "@/modules/frontend/pages/Market_Place/market-place-style.scss";
import ProductCard from "../../components/Market_Place/Product/ProductCard";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getMarketPlaceHomeData } from "@/store/modern/slices/marketPlaceSlice";
import { favoriteProduct } from "@/store/modern/slices/productSlice";
import { find, findIndex, isEmpty, map, size } from "lodash";
import ConsentManager from "@/modules/frontend/components/ConsentManager";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import BookADemo from "../../components/BookADemo";
import PopUp from "../../components/PopUp";
import RegistrationPopup from "@/components/RegistrationPopup";
import { useAuth } from "@/AuthProvider";
import { showSuccessMessage } from "@/utils/common";


function MarketPlacePage() {

  const nav = useNavigate();
  const { user } = useAuth();
  const dispatch = useDispatch();
  const partnerBannersRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [registerModalShow, setRegisterModalShow] = useState(false);


  const options = {
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 1,
      },
      768: {
        items: 2,
      },
      1000: {
        items: 3,
      },
      1680: {
        items: 4,
      }
    },
    autoplay: true,
    autoplayTimeout: 30000,
    smartSpeed: 800,
    nav: false,
    dots: false
  }

  const marketplaceData = useSelector((state) => state.marketPlace.marketplaceData, shallowEqual);

  //const { latest_products, suppliers, trending_products } = marketplaceData;

  const [latestProducts, setLatestProducts] = useState([]);
  const [trendingProducts, setTrendingProducts] = useState([]);
  const [suppliers, setSuppliers] = useState([]);

  const data = [
    {
      title: "List Product",
      content:
        "Suppliers can list products quickly and reach a global audience, increasing visibility and attracting high-quality inquiries",
    },
    {
      title: "Explore Products",
      content:
        "Explore a wide range of products across multiple categories from trusted and verified suppliers worldwide.",
    },
    {
      title: "Connect with Suppliers",
      content:
        "Send direct inquiries to suppliers, get detailed information, negotiate pricing and close deals efficiently.",
    },
  ];

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  const goToNext = () => {
    partnerBannersRef.current.next();
  };

  const goToPrev = () => {
    partnerBannersRef.current.prev();
  };

  const toggleItem = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const goToSlide = (index) => {
    console.log("goToSlide >>>> ", index);
    if (partnerBannersRef.current) {
      // The .to() method accepts (index, speed_in_ms)
      partnerBannersRef.current.to(index, 500);
    }
  };

  const handlefavoriteClick = async (pdata) => {
    if(user) {
      let reqObj = {
        product_id : pdata.id
      }
      const response = await dispatch(favoriteProduct(reqObj));
      if(response && response.type === "products/favoriteProduct/fulfilled") {
        if(response.payload.status) {
          showSuccessMessage(response.payload.message);  

          /* let tp = [...trendingProducts];
          // dispatch(getMarketPlaceHomeData());
          let tProductFound = find(tp,(val) => val.id === pdata.id);
          let tpIndex = findIndex(tp,(val) => val.id === pdata.id);
          let updatedItem = tProductFound;
          if(tProductFound) {
             if(response.payload.message === "Product removed from favorite") {
              updatedItem = { ...tProductFound, isFavorite: false };
             } else {
              updatedItem = { ...tProductFound, isFavorite: true };
             }
             tp[tpIndex] = updatedItem;
             setTrendingProducts(tp);
            // setTimeout(() => goToSlide(tpIndex) , 300);

          } 

          let lp = [...latestProducts];
          let lProductFound = find(lp,(val) => val.id === pdata.id);
          let lpIndex = findIndex(lp,(val) => val.id === pdata.id);
          let lupdatedItem = lProductFound;
          if(lProductFound) {
             if(response.payload.message === "Product removed from favorite") {
              lupdatedItem = { ...lProductFound, isFavorite: false };
             } else {
              lupdatedItem = { ...lProductFound, isFavorite: true };
             }
             lp[lpIndex] = lupdatedItem;
             setLatestProducts(lp);
          } */
        }
      }
    } else {
      setRegisterModalShow(true);
    }
  }

  const handleRegisterBtnClick = () => {
    nav(publicRoutePaths.REGISTRATION.path);
  }

  const fetchData = async () => {
    const response = await dispatch(getMarketPlaceHomeData());
    if(response && response.type === "marketplace/getMarketPlaceHomeData/fulfilled") {
      if(response.payload) {
        setTrendingProducts(response.payload.trending_products);
        setLatestProducts(response.payload.latest_products);
        setSuppliers(response.payload.suppliers);
      }
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <section className="market-place-wrape">
      <SeoHelmet
        title={seoConfig.marketplaceHome.title}
        description={seoConfig.marketplaceHome.description}
        keywords={seoConfig.marketplaceHome.keywords}
        author={seoConfig.marketplaceHome.author}
      />
      <button
        className="btn outline small sticky-btn"
        onClick={handleQuoteClick}
        type="button"
      >
        Book A Demo
      </button>
      {/* inner banner wrape START */}
      <div className="inner-banner">
        <div className="container">
          <div className="content-wrape desk-hide">
            <h2>
              <span className="light">Discover the</span>
              <span className="blue-text"> Best Products</span>
              <span className="black"> in One Place</span>
            </h2>
            <p>
              Explore a wide range of offerings and connect directly with trusted suppliers.
            </p>
          </div>
        </div>
      </div>
      {/* inner banner wrape END */}

      {/* ================= CONTENT ================= */}
      <div className="inner-page-content-wrape market-place-page">
        <div className="container introduction">
          {/* Mobile Heading */}
          <div className="content-wrape mobile-show page-head">
            <h2 className="mobile-head-text">
              <span className="light">Discover the</span>
              <span className="blue-text"> Best Products</span>
              <span className="black"> in One Place</span>
            </h2>
            <p>
              Explore a wide range of offerings and connect directly with trusted suppliers.
            </p>
          </div>

          {/* Commodities */}
          <div className="row">
            <div className="col-xxl-12">
              <div className="head-text">
                <h1 className="head">Commodities</h1>
              </div>
            </div>

            <div className="col-xxl-12">
              <div className="industry-wrapes">
                <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=agriculture`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}/?category=agriculture`} className="industry-pad" title="Agriculture">
                  <img src={Agriculture} alt="Agriculture" />
                  <span>Agriculture</span>
                </Link>

                <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=pharmaceuticals`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}?category=pharmaceuticals`} className="industry-pad" title="Pharmaceuticals">
                  <img src={Pharmaceuticals} alt="Pharmaceuticals" />
                  <span>Pharmaceuticals</span>
                </Link>

                <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=ceramic`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}?category=ceramic`} className="industry-pad" title="Ceramic">
                  <img src={Ceramic} alt="Ceramic" />
                  <span>Ceramic</span>
                </Link>

                <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=textiles`} target="_blank" className="industry-pad" title="Textiles" href={`${publicRoutePaths.MARKET_DETAIL.path}?category=textiles`}>
                  <img src={Textiles} alt="Textiles" />
                  <span>Textiles</span>
                </Link>

                <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=building-materials`} target="_blank" className="industry-pad" title="Building Materials" href={`${publicRoutePaths.MARKET_DETAIL.path}?category=building-material`}>
                  <img src={BuildingMaterials} alt="Building Materials" />
                  <span>Building <br /> Materials</span>
                </Link>

                <Link
                  to={`${publicRoutePaths.MARKET_DETAIL.path}?category=automobile-and-auto-parts`}
                  className="industry-pad"
                  title="Automobile & Auto Parts"
                  target="_blank"
                  href={`${publicRoutePaths.MARKET_DETAIL.path}?category=automobile-and-auto-parts`}
                >
                  <img src={Automobile} alt="Automobile & Auto Parts" />
                  <span>
                    Automobile <br /> & Auto Parts
                  </span>
                </Link>

                <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=fmcg`} href={`${publicRoutePaths.MARKET_DETAIL.path}?category=fmcg`} className="industry-pad" title="FMCG" target="_blank">
                  <img src={FMCG} alt="FMCG" />
                  <span>FMCG</span>
                </Link>

                <Link
                  to={`${publicRoutePaths.MARKET_DETAIL.path}?category=cosmetics-and-personal-care`}
                  className="industry-pad"
                  title="Cosmetics & Personal Care"
                  target="_blank"
                  href={`${publicRoutePaths.MARKET_DETAIL.path}?category=cosmetics-and-personal-care`}
                >
                  <img src={Cosmetics} alt="Cosmetics & Personal Care" />
                  <span>
                    Cosmetics & <br /> Personal Care
                  </span>
                </Link>

                <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=food-products`} className="industry-pad" title="Food Products" target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}?category=food-products`} >
                  <img src={Food} alt="Food Products" />
                  <span>
                    Food <br /> Products
                  </span>
                </Link>

                <Link
                  to={`${publicRoutePaths.MARKET_DETAIL.path}?category=electronics-and-gadgets`}
                  className="industry-pad"
                  title="Electronics & Gadgets"
                  target="_blank"
                  href={`${publicRoutePaths.MARKET_DETAIL.path}?category=electronics-and-gadgets`}
                >
                  <img src={Electronics} alt="Electronics & Gadgets" />
                  <span>
                    Electronics <br /> & Gadgets
                  </span>
                </Link>

                <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=oil-gas`} href={`${publicRoutePaths.MARKET_DETAIL.path}?category=oil-gas`} className="industry-pad" title="Oil & Gas" target="_blank">
                  <img src={Oil} alt="Oil & Gas" />
                  <span>Oil & Gas</span>
                </Link>

                <Link
                  to={`${publicRoutePaths.MARKET_DETAIL.path}?category=all`} href={`${publicRoutePaths.MARKET_DETAIL.path}?category=all`}
                  className="industry-pad explore-btn"
                  title="Explore More"
                  target="_blank"
                >
                  <i className="sprite explore"></i>
                  <span>Explore More</span>
                </Link>

              </div>
            </div>
          </div>

          {/* Trending Products START */}
          <div className="tranding-wrape">
            <div className="row">
              <div className="col-xxl-12">

                <div className="head-text button-head">
                  <h2 className="head">Trending Products</h2>

                  {/* <div className="btn-wrape">
                    <Link
                      className="btn outline"
                      to="/"
                      title="View All Products"
                    >
                      View All Products
                      <span className="round">
                        <i className="sprite"></i>
                      </span>
                    </Link>
                  </div> */}
                  <div className="nav-ctrl">
                    <button type="button" className="btn prev" onClick={goToPrev}>
                      <i className="sprite"></i>
                    </button>
                    <button type="button" className="btn next" onClick={goToNext}>
                      <i className="sprite"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-xxl-12">
                <div className="row">
                  {
                    size(trendingProducts) > 0 && <OwlCarousel className='owl-theme section' margin={20} {...options} autoplay ref={partnerBannersRef} key={JSON.stringify(map(trendingProducts, p => `${p.id}_${p.isFavorite}`))} >
                      {
                        map(trendingProducts, (val, k) => {
                          return (<div className="review item" key={`trending_${k}`}>
                            <ProductCard data={val} favKey={`fav_product_${val.id + '_'+ Date.now()}`} key={`s_${k}`} showContact={false} showDesc={true} showPrice={false} handlefavoriteClick={handlefavoriteClick} />
                          </div>)
                        })
                      }
                    </OwlCarousel>
                  }

                </div>
              </div>
            </div>
          </div>
          {/* Trending Products END */}
        </div>

        {/* Supplier Slider wrape START */}
        <div className="supplier-slider-wrape">
          <div className="container">
            <div className="row">
              <div className="col-xxl-12">
                {
                  size(suppliers) > 0 && <SupplierCarousel suppliers={suppliers} />
                }
              </div>
            </div>
          </div>
        </div>
        {/* Supplier Slider wrape START */}
      </div>

      {/* why do we wrape START */}
      <div className="why-do-we-wrape">
        <div className="container">
          <div className="row">
            <div className="col-xxl-2"></div>
            <div className="col-xxl-8">
              <div className="inner-pad">
                <h3>Why Do We Use it?</h3>
                <p>Get the best deals from trusted manufacturers, traders and distributors worldwide - all in one place</p>
                <Link className="btn outline" to={publicRoutePaths.REGISTRATION.path} target="_blank" href={publicRoutePaths.REGISTRATION.path} title="Register Today">
                  Register Today
                  <span className="round">
                    <i className="sprite"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* why do we Wrape END */}


      {/* Latest Products START */}
      <div className="container introduction">
        <div className="tranding-wrape">
          <div className="row">
            <div className="col-xxl-12">
              <div className="head-text button-head">
                <h2 className="head">New Products</h2>

                <div className="btn-wrape">
                  <Link
                    className="btn outline medium"
                    to={`${publicRoutePaths.MARKET_DETAIL.path}?category=all`}
                    title="View All Products"
                    href={`${publicRoutePaths.MARKET_DETAIL.path}?category=all`}
                    target="_blank"
                  >
                    View All Products
                    <span className="round">
                      <i className="sprite"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-xxl-12">
              <div className="row">
                {
                  size(latestProducts) > 0 && map(latestProducts, (val, k) => {
                    return (<div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" key={`latest_${k}`}><ProductCard favKey={`fav_product_${val.id + '_'+ Date.now()}`} data={val} showContact={false} showDesc={true} showPrice={false} handlefavoriteClick={handlefavoriteClick} key={JSON.stringify(map(latestProducts, p => `${p.id}_${p.isFavorite}`))}/></div>)
                  })
                }

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Latest Products END */}

      <div className="inner-page-content-wrape market-place-page">
        <div className="container introduction">
          {/* stats faq wrape START */}
          <div className="stats-faq-wrape">
            <div className="container">
              <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12">
                  <div className="head-text">
                    <h2 className="head">Streamline your sourcing process</h2>
                  </div>

                  {/* Accordion START */}
                  <div className="accordion">
                    {data.map((item, index) => (
                      <article
                        key={`accordian_${index}`}
                        className={`accordion-item ${activeIndex === index ? "active" : ""
                          }`}
                      >
                        <button
                          className="accordion-header"
                          onClick={() => toggleItem(index)}
                        >
                          {item.title}
                        </button>

                        <div className="accordion-content">
                          {activeIndex === index && <p>{item.content}</p>}
                        </div>
                      </article>
                    ))}
                  </div>
                  {/* Accordion END */}
                </div>

                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12">
                  <img src={StatesImg} alt="" />
                </div>
              </div>
            </div>
          </div>
          {/* stats faq wrape START */}
        </div>
      </div>

      <ConsentManager />

      {smallmodalShow && (
        <PopUp
          title="Book A Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}


      {
        registerModalShow && <RegistrationPopup
        title=""
        smallmodalShow={registerModalShow}
        setSmallModalShow={setRegisterModalShow}
        onSubmit={handleRegisterBtnClick}
        okButtonLabel="REGISTER NOW"
      >
        <div className="new-pop">
          <div className="img-wrape"></div>
          <div className="detail-wrape">
            <div className="inner">
              <h5 className="registor-now">Grow With Us!</h5>
              <h6>Register now to get more benefits!</h6>
              <p className="registor-now-text">
                Access special features, get personalized recommendations and connect with a growing community.
              </p>
              <Link to={publicRoutePaths.REGISTRATION.path} className="btn secondry-btn" target="_blank" href={publicRoutePaths.REGISTRATION.path} >Register Now</Link>
            </div>
          </div>
        </div>
      </RegistrationPopup>
      }

    </section>
  );
}

export default MarketPlacePage;